import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  isValidCheckout: true,
  isVisibleModal: false,
  isVisibleDifal: false,
};

const DifalSlice = createSlice({
  name: 'DifalSlice',
  initialState,
  reducers: {
    setIsValidToCheckout: (state, action) => {
      state.isValidCheckout = action.payload;
    },
    setIsVisibleModal: (state, action) => {
      state.isVisibleModal = action.payload;
    },
    setIsVisibleDifal: (state, action) => {
      state.isVisibleDifal = action.payload;
    },
  },
});

export const { setIsValidToCheckout, setIsVisibleModal, setIsVisibleDifal } =
  DifalSlice.actions;
export default DifalSlice.reducer;
